// branch-map.js — the store page's mini-map (main-branch.liquid), one pin
// for this store, not draggable. Google Maps through assets/gmap.js: with
// a key, the dark map and the site's orange pin at Google's geocode of the
// street address; without one, Google's plain embedded map of the address.
//
// The panel ships with `.map-unavailable` and a real address card, and this
// script only removes the class once a map is in place, so any failure
// leaves the address card showing. A click anywhere on the map opens
// directions to the store in Google Maps. Guarded `window.__tmgBranchMap`
// singleton + `shopify:section:load` re-init, as in locator.js.
if (!window.__tmgBranchMap) {
  (function () {
    function init() {
      var panel = document.querySelector('[data-branch-map]');
      if (!panel || panel.__tmgMapDone || !window.TMG_GMAP) return;
      panel.__tmgMapDone = true;

      var lat = parseFloat(panel.getAttribute('data-lat'));
      var lng = parseFloat(panel.getAttribute('data-lng'));
      var status = panel.getAttribute('data-status') || 'open';
      var address = panel.getAttribute('data-address') || '';
      var name = panel.getAttribute('data-name') || '';
      var dirUrl = panel.getAttribute('data-directions') || '';
      var dirLabel = panel.getAttribute('data-directions-label') || '';

      window.TMG_GMAP.ready(function (ok) {
        if (ok && isFinite(lat) && isFinite(lng)) {
          var stored = new google.maps.LatLng(lat, lng);
          var map = window.TMG_GMAP.create(panel, { center: stored, zoom: 15, gestureHandling: 'none', zoomControl: false });
          var pin = window.TMG_GMAP.pin(map, stored, status === 'open' ? 'pin-open' : 'pin-coming');
          window.TMG_GMAP.locate(address, stored, function (pos) { pin.moveTo(pos); map.setCenter(pos); });
          panel.classList.add('is-map');
          window.TMG_GMAP.fallback(panel, address || lat + ',' + lng, 15, name, map);
        } else if (address) {
          window.TMG_GMAP.embed(panel, address, 15, name);
        } else {
          return;
        }
        // a click anywhere on the map: directions in Google Maps
        window.TMG_GMAP.link(panel, dirUrl, dirLabel);
        panel.classList.remove('map-unavailable');
      });
    }

    document.addEventListener('shopify:section:load', function () {
      var panel = document.querySelector('[data-branch-map]');
      if (panel) panel.__tmgMapDone = false;
      window.__tmgBranchMap.init();
    });

    window.__tmgBranchMap = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
}
